import { func, number } from 'prop-types'
import { PureComponent } from 'react'
import { kuiperClassNames } from '../../utils'

import './styles.scss'

class ColumnSizer extends PureComponent {
  static propTypes = {
    index: number,
    onChangeWidth: func,
  }

  constructor(props) {
    super(props)
    this.state = {
      draggerX: 0,
      isDragging: false,
    }
  }

  onBeginDrag = (e) => {
    document.addEventListener('mousemove', this.setDraggerXPosition)
    document.addEventListener('mouseup', this.changeColumnWidth)
    this.setState({ isDragging: true, startX: e.clientX })
  }

  changeColumnWidth = (e) => {
    document.removeEventListener('mousemove', this.setDraggerXPosition)
    document.removeEventListener('mouseup', this.changeColumnWidth)
    const widthChange = e.clientX - this.state.startX
    this.setState(
      { isDragging: false, draggerX: 0, startX: 0 },
      this.props.onChangeWidth({ index: this.props.index, widthChange })
    )
  }

  setDraggerXPosition = (e) => {
    this.setState(({ startX, isDragging }) =>
      isDragging ? { draggerX: e.clientX - startX } : null
    )
  }

  render() {
    const { isDragging, draggerX } = this.state

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        className={kuiperClassNames('columnSizer', { isDragging })}
        onMouseDown={this.onBeginDrag}
        style={{ transform: `translate3D(${draggerX}px,0,0)` }}
      />
    )
  }
}

export default ColumnSizer
